import React, { FC, PropsWithChildren } from 'react';

type EndQuoteProps = {
  /** The color of the icon. */
  color?: string;
};

const EndQuote: FC<PropsWithChildren<EndQuoteProps>> = ({ color = '#FFCA73' }) => (
  <svg fill="none" height="43" viewBox="0 0 70 43" width="70" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M32.1839 23.8293C32.429 24.9188 32.5581 26.0502 32.5581 27.2109C32.5581 35.931 25.2698 43 16.2791 43C7.28839 43 1.23598e-06 35.931 2.76065e-06 27.2109C4.28531e-06 18.4909 7.28839 11.4219 16.2791 11.4219C16.3963 11.4219 16.5133 11.4231 16.63 11.4255L16.6255 11.4219C15.1246 8.51042 11.1529 2.15 7.27367 1.27177e-06C14.8937 1.56771 30.5493 8.53282 32.2118 23.8516L32.1839 23.8293Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M69.6258 23.8293C69.8709 24.9188 70 26.0502 70 27.2109C70 35.931 62.7116 43 53.7209 43C44.7302 43 37.4419 35.931 37.4419 27.2109C37.4419 18.4909 44.7303 11.4219 53.7209 11.4219C53.8382 11.4219 53.9552 11.4231 54.0718 11.4255L54.0673 11.4219C52.5664 8.51042 48.5948 2.15 44.7155 1.27176e-06C52.3355 1.56771 67.9911 8.53282 69.6536 23.8516L69.6258 23.8293Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default EndQuote;
